import { CallToActionEnum } from 'api';

export const LEAD_GENERATION_ALLOW: CallToActionEnum[] = [
  CallToActionEnum.APPLY_NOW,
  CallToActionEnum.BOOK_TRAVEL,
  CallToActionEnum.DOWNLOAD,
  CallToActionEnum.GET_OFFER,
  CallToActionEnum.GET_QUOTE,
  CallToActionEnum.LEARN_MORE,
  CallToActionEnum.SIGN_UP,
  CallToActionEnum.SUBSCRIBE
];

export const APP_INSTALLS_ALLOW: CallToActionEnum[] = [
  CallToActionEnum.BOOK_TRAVEL,
  CallToActionEnum.DOWNLOAD,
  CallToActionEnum.INSTALL_MOBILE_APP,
  CallToActionEnum.LEARN_MORE,
  CallToActionEnum.LISTEN_NOW,
  CallToActionEnum.PLAY_GAME,
  CallToActionEnum.SHOP_NOW,
  CallToActionEnum.SIGN_UP,
  CallToActionEnum.SUBSCRIBE,
  CallToActionEnum.USE_APP,
  CallToActionEnum.WATCH_MORE,
  CallToActionEnum.BUY_NOW
];

export const REACH_ALLOW: CallToActionEnum[] = [
  CallToActionEnum.APPLY_NOW,
  CallToActionEnum.BOOK_TRAVEL,
  CallToActionEnum.CONTACT_US,
  CallToActionEnum.DOWNLOAD,
  CallToActionEnum.GET_QUOTE,
  CallToActionEnum.GET_SHOWTIMES,
  CallToActionEnum.LEARN_MORE,
  CallToActionEnum.LISTEN_NOW,
  CallToActionEnum.REQUEST_TIME,
  CallToActionEnum.SHOP_NOW,
  CallToActionEnum.SIGN_UP,
  CallToActionEnum.SUBSCRIBE,
  CallToActionEnum.WATCH_MORE
  // CallToActionEnum.SAVE,
  // CallToActionEnum.SEE_MENU,
  // CallToActionEnum.SEND_MESSAGE,
  // CallToActionEnum.GET_DIRECTIONS,
];

export const LINK_CLICKS_ALLOW: CallToActionEnum[] = [
  CallToActionEnum.APPLY_NOW,
  CallToActionEnum.BOOK_TRAVEL,
  CallToActionEnum.CONTACT_US,
  CallToActionEnum.DONATE_NOW,
  CallToActionEnum.DOWNLOAD,
  CallToActionEnum.GET_QUOTE,
  CallToActionEnum.GET_SHOWTIMES,
  CallToActionEnum.LEARN_MORE,
  CallToActionEnum.LISTEN_NOW,
  CallToActionEnum.SHOP_NOW,
  CallToActionEnum.SIGN_UP,
  CallToActionEnum.SUBSCRIBE,
  CallToActionEnum.WATCH_MORE
];

export const POST_ENGAGEMENT_ALLOW: CallToActionEnum[] = [
  CallToActionEnum.GET_QUOTE,
  CallToActionEnum.LEARN_MORE,
  CallToActionEnum.SHOP_NOW
  // CallToActionEnum.SEND_MESSAGE,
];

export const PAGE_LIKES_ALLOW: CallToActionEnum[] = [
  CallToActionEnum.GET_QUOTE,
  CallToActionEnum.LEARN_MORE,
  CallToActionEnum.SHOP_NOW
];

export const VIDEO_VIEWS_ALLOW: CallToActionEnum[] = [
  CallToActionEnum.BOOK_TRAVEL,
  CallToActionEnum.DOWNLOAD,
  CallToActionEnum.GET_QUOTE,
  CallToActionEnum.GET_SHOWTIMES,
  CallToActionEnum.LEARN_MORE,
  CallToActionEnum.LISTEN_NOW,
  CallToActionEnum.SHOP_NOW,
  CallToActionEnum.SIGN_UP,
  CallToActionEnum.SUBSCRIBE,
  CallToActionEnum.WATCH_MORE
  // CallToActionEnum.SEND_MESSAGE,
];

export const CONVERSIONS_ALLOW: CallToActionEnum[] = [
  CallToActionEnum.APPLY_NOW,
  CallToActionEnum.BOOK_TRAVEL,
  CallToActionEnum.CONTACT_US,
  CallToActionEnum.DONATE_NOW,
  CallToActionEnum.DOWNLOAD,
  CallToActionEnum.GET_OFFER,
  CallToActionEnum.GET_QUOTE,
  CallToActionEnum.GET_SHOWTIMES,
  CallToActionEnum.LEARN_MORE,
  CallToActionEnum.LISTEN_NOW,
  CallToActionEnum.PLAY_GAME,
  CallToActionEnum.REQUEST_TIME,
  CallToActionEnum.SHOP_NOW,
  CallToActionEnum.SIGN_UP,
  CallToActionEnum.SUBSCRIBE,
  CallToActionEnum.USE_APP,
  CallToActionEnum.WATCH_MORE
  // CallToActionEnum.SEE_MENU,
];
